module.exports = __webpack_public_path__ + "img/icon-listagem.dac42423.svg";